module.exports = __webpack_public_path__ + "img/cliente-em-primeiro-lugar.a17c1649.jpg";